<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="leaving-ohio">
<h1>Leaving Ohio</h1>
<p style="text-indent:0em">Leaving that farm town seemed so easy,</p>
<p style="text-indent:0em">driving past knee-high corn fields</p>
<p style="text-indent:0em">and browning wheat fields,</p>
<p style="text-indent:0em">suitcase in back, airport ahead.</p><br/>
<p style="text-indent:0em">I didn’t realize it then, but I’d never return</p>
<p style="text-indent:0em">to the city park and horseshoe pits,</p>
<p style="text-indent:0em">back road racing and back road parking,</p>
<p style="text-indent:0em">and local spots only the boys all knew.</p><br/>
<p style="text-indent:0em">In our story-telling nights, the girls</p>
<p style="text-indent:0em">were always wilder than our truth,</p>
<p style="text-indent:0em">but boys must be boys before</p>
<p style="text-indent:0em">they grow out from youth.</p><br/>
<p style="text-indent:0em">And so, the hot rod cars and</p>
<p style="text-indent:0em">green football jerseys and</p>
<p style="text-indent:0em">late-night skinny-dipping world</p>
<p style="text-indent:0em">quietly was laid to rest.</p><br/>
<p style="text-indent:0em">We all go back, but only to visit.</p>
<p style="text-indent:0em">The past is just a photograph</p>
<p style="text-indent:0em">of what was, never to be again,</p>
<p style="text-indent:0em">pictures of what can never change.</p><br/>
<p style="text-indent:0em">The pages turn, the chapters close.</p>
<p style="text-indent:0em">The years of youth, like us, disappear</p>
<p style="text-indent:0em">in the perpetual motion of the clock,</p>
<p style="text-indent:0em">never to return.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?67412fe7